import { Injectable, signal } from '@angular/core';
import { IKioskTab } from '../interfaces/IKioskTab';
import { IKioskProductsAndPackages } from '../interfaces/IKioskProductsAndPackages';

@Injectable({
  providedIn: 'root'
})
export class KioskStore {

  public readonly rejectedPackagesToConvertIds = signal<number[]>([]);
  public readonly kioskTabs = signal<IKioskTab[]>([]);
  public readonly kioskProductsAndPackages = signal<IKioskProductsAndPackages>(null);
}
